import React from "react";
import Moment from "react-moment";
import { Button, Grid } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import useScrollToTop from "../../components/CustomHooks/useScrollToTop";

function VtrList({ vtrs, editClick, pdfHandler }) {
  useScrollToTop();

  return (
    <div
      style={{
        width: "100%",
        height: "auto",
      }}
    >
      <Grid container justifyContent="center" alignItems="center">
        <List
          style={{
            border: "solid 1px #ACACAC",
            borderRadius: "5px",
            marginTop: "20px",
          }}
          component="nav"
          dense
          aria-label="main"
        >
          {vtrs.map((vtr, idx) => {
            return (
              <div key={idx}>
                <ListItem button>
                  <ListItemText>{`Trip: ${
                    vtr.SUBMISSION_TYPE.toUpperCase() === "PAPER"
                      ? vtr.LOWEST_SERIAL_NUM
                      : vtr.TRIP_ID
                  }`}</ListItemText>
                  <ListItemIcon>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      className="form-input edit-button"
                      size="large"
                      onClick={editClick}
                      key={"edit_" + vtr.TRIP_ID}
                      data-trip-id={vtr.TRIP_ID}
                      style={{ width: "85px" }}
                      disabled={vtr.IS_LOCKED === "1"}
                    >
                      Edit
                    </Button>
                  </ListItemIcon>
                </ListItem>
                <ListItem button>
                  <ListItemText>
                    Date Sailed:{" "}
                    <Moment parse={"YYMMDD LT"} format={"DD-MMM-YY LT"}>
                      {vtr.DATE_SAIL}
                    </Moment>
                  </ListItemText>
                  <ListItemIcon>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      className="form-input pdf-save-button"
                      size="large"
                      onClick={pdfHandler("save")}
                      key={"pdf_save_" + vtr.TRIP_ID}
                      data-trip-id={vtr.TRIP_ID}
                      style={{ width: "85px" }}
                    >
                      Download PDF
                    </Button>
                  </ListItemIcon>
                </ListItem>
                <ListItem button>
                  <ListItemText>
                    Date Landed:{" "}
                    <Moment parse={"YYMMDD LT"} format={"DD-MMM-YY LT"}>
                      {vtr.DATE_LAND}
                    </Moment>
                  </ListItemText>
                  <ListItemIcon>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      className="form-input pdf-view-button"
                      size="large"
                      onClick={pdfHandler("view")}
                      key={`pdf_view_${vtr.TRIP_ID}`}
                      data-trip-id={vtr.TRIP_ID}
                      style={{ width: "85px" }}
                    >
                      View PDF
                    </Button>
                  </ListItemIcon>
                </ListItem>
                <ListItem divider>
                  <ListItemText>{`Permit Nbr: ${vtr.VESSEL_PERMIT_NUM}`}</ListItemText>
                </ListItem>
              </div>
            );
          })}
        </List>
      </Grid>
    </div>
  );
}

export default VtrList;
